import React, { useState } from "react";
import "./modal-delete.css";
import { Dialog } from "@progress/kendo-react-dialogs";
import PrimaryBtn from "../../pures/primaryBtn/primary-btn.pure";
import ModalRequst from "../modal-request/modal-requst-pure";
import { Label } from "@progress/kendo-react-labels";
import { useTranslation } from "react-i18next";
import ButtonHLPure from "../buttonHL/buttonHL.pure";

export default function ({
  toggleDialog,
  deleteElement,
  fetchElement,
  fetchDelete,
  textError,
  isDeleteByVolume,
  ...props
}) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const onSubmit = () => {
    if (isDeleteByVolume) {
      setIsLoading(true);
      deleteElement();
      setSuccess(true);

      setTimeout(() => {
        setIsLoading(false);
        setSuccess(false);
        toggleDialog();
      }, 3000);
    } else {
      setIsLoading(true);
      deleteElement()
        .then(() => {
          setIsLoading(false);
          setSuccess(true);
          // fetchElement()
          setTimeout(() => {
            setSuccess(false);
            toggleDialog();
            window.location.reload();
          }, 3000);
        })
        .catch((err) => {
          setIsLoading(false);
          setError(err);
          setTimeout(() => {
            setError(null);
            toggleDialog();
          }, 3000);
        });
    }
  };

  let title = t("ModalDelete.title");
  if (isLoading || error || success) {
    title = t("ModalDelete.a3Title");
  }
  return (
    <Dialog className="modal-delete" title={title} onClose={toggleDialog}>
      <ModalRequst
        isLoading={isLoading}
        error={error}
        textError={textError}
        success={success}
      >
        <div className="btn-modal-delete">
          <Label className="modalDelete-labels">
            {props.deleteText || t("ModalDelete.deleteText")}
          </Label>
        </div>
        <div className="modal-delete-container-btns">
          <ButtonHLPure
            nameBtn={t("ModalDelete.cancel")}
            primary={false}
            onClickBtn={toggleDialog}
          />
          <ButtonHLPure
            nameBtn={t("ModalDelete.delete")}
            primary={true}
            onClickBtn={onSubmit}
          />
        </div>
      </ModalRequst>
    </Dialog>
  );
}
